module.exports = __webpack_public_path__ + "static/IMG-20200830-WA0005-fe1544a6f590b2fcd0b9a4d39c766d4a.jpg";